import { useEffect, useState } from 'react'

import { TripTypeEnum } from '../../../lib/types/enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../../lib/types/enums/trip-bookings/trip-step-type.enum'
import { TripBookingTypes } from '../../../lib/types/models/trip-booking/trip-booking'
import { TripBookingDetails, TripBookingTabs } from '../trip-bookings/trip-booking.ui'

type TripBookingDetailsProps = {
  tripType: TripTypeEnum
  tripBookings: TripBookingTypes.Partial[]
  directionality: TripStepTypeEnum
  onTripBookingChange?: (tripBooking: TripBookingTypes.Partial) => void
}

export function TripBookingDetailedSection({
  tripType,
  tripBookings,
  directionality,
  onTripBookingChange
}: TripBookingDetailsProps) {
  const [activeTab, setActiveTab] = useState(0)

  // clamp the active tab when the trip bookings list shrinks
  useEffect(() => {
    if (activeTab > tripBookings.length - 1) setActiveTab(Math.max(0, tripBookings.length - 1))
  }, [tripBookings, activeTab])

  const activeTripBooking = tripBookings.at(activeTab)

  return (
    <div className={'flex flex-col gap-4'}>
      <TripBookingTabs
        tripType={tripType}
        tripBookings={tripBookings}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        directinality={directionality}
        onTripBookingChange={(tripBooking) => onTripBookingChange?.(tripBooking)}
      />
      <TripBookingDetails tripBooking={activeTripBooking} directionality={directionality} />
    </div>
  )
}
